// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3pkbl","title":"InfoRow_title__1dDOi"};